/* ============================================================
   Carrusel móvil reutilizable (Mar de Flores) — sin librerías
   Activa cualquier contenedor con [data-mdf-carousel]:
   - swipe nativo (scroll-snap, lo pone el CSS)
   - puntos de paginación sincronizados con el scroll
   - autoplay opcional: data-mdf-autoplay="4500" (ms)
   - autoplay solo cuando la sección está en pantalla; pausa al tocar
   - respeta prefers-reduced-motion (sin autoplay, sin scroll animado)
   Solo se comporta como carrusel en móvil (<=767px); en desktop
   el contenedor conserva su layout y los puntos quedan ocultos por CSS.
   ============================================================ */
(function () {
  function slidesOf(car) {
    return Array.prototype.filter.call(car.children, function (c) {
      return c.nodeType === 1 && !c.classList.contains('mdf-dots');
    });
  }

  function init(car) {
    if (car.__mdfInit) return;
    var slides = slidesOf(car);
    if (slides.length < 2) return;
    car.__mdfInit = true;

    var mqMobile = window.matchMedia('(max-width: 767px)');
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var autoplay = parseInt(car.getAttribute('data-mdf-autoplay') || '0', 10);
    var current = 0, raf = 0, timer = 0, resumeT = 0, inView = false;

    var dots = document.createElement('div');
    dots.className = 'mdf-dots';
    dots.setAttribute('role', 'tablist');
    var btns = slides.map(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mdf-dots__dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () { goTo(i); pause(); });
      dots.appendChild(b);
      return b;
    });
    car.parentNode.insertBefore(dots, car.nextSibling);

    function slideDelta(i) {
      return slides[i].getBoundingClientRect().left - car.getBoundingClientRect().left;
    }
    function setActive(i) {
      for (var k = 0; k < btns.length; k++) {
        btns[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
      }
    }
    function goTo(i, smooth) {
      i = (i + slides.length) % slides.length;
      current = i;
      car.scrollTo({
        left: Math.max(0, car.scrollLeft + slideDelta(i)),
        behavior: (smooth === false || mqReduce.matches) ? 'auto' : 'smooth'
      });
      setActive(i);
    }
    function nearest() {
      var base = car.getBoundingClientRect().left, best = 0, bd = Infinity;
      for (var k = 0; k < slides.length; k++) {
        var d = Math.abs(slides[k].getBoundingClientRect().left - base);
        if (d < bd) { bd = d; best = k; }
      }
      return best;
    }
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; current = nearest(); setActive(current); });
    }
    function start() {
      stop();
      if (!autoplay || mqReduce.matches || !mqMobile.matches) return;
      timer = setInterval(function () { if (inView) goTo(current + 1); }, autoplay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = 0; } }
    function pause() {
      stop();
      if (resumeT) clearTimeout(resumeT);
      resumeT = setTimeout(start, 7000);
    }

    car.addEventListener('scroll', onScroll, { passive: true });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      car.addEventListener(ev, pause, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        inView = e[0].isIntersecting;
        if (inView) start(); else stop();
      }, { threshold: 0.3 }).observe(car);
    } else {
      inView = true; start();
    }

    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', function () { setActive(current); start(); });
    }
    setActive(0);
  }

  function boot() {
    var list = document.querySelectorAll('[data-mdf-carousel]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
